/**
 * 头部导航
 */
export default {
  signIn: 'Sign in',
  signOut: 'Sign Out',
}
